import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import Layout from '../../components/Layout'
import { getMenu, updateMenu, createMenu } from '../../api/menu'
import { connect } from 'react-redux'
import {
    SET_MENU,
    ADD_MENU_ITEM,
    SET_MENU_CHANGES_FALSE,
} from '../../actions/constants'
import SortableLinksList from '../../components/SortableLinksList'

class Menu extends Component {
    constructor(props) {
        super(props)
        this.state = {
            site: props.match.params.id,
            isLoading: true,
        }
    }

    componentDidMount() {
        // get sites menu
        getMenu({ site: this.state.site }).then((menu) => {
            // set menu in redux
            this.props.dispatch({
                type: SET_MENU,
                payload: {
                    menu: menu.data[0],
                },
            })

            // update local loading state
            this.setState({
                isLoading: false,
            })
        })
    }

    saveMenu = () => {
        updateMenu(this.props.menu).then(() => {
            console.log('menu updated')
            this.props.dispatch({
                type: SET_MENU_CHANGES_FALSE,
            })
        })
    }

    newParentLink = () => {
        let newLink = {
            title: 'Untitled',
            link: '#',
            target: '_self',
            external: false,
            sublinks: [],
        }

        this.props.dispatch({
            type: ADD_MENU_ITEM,
            payload: {
                newLink,
            },
        })

        // let newMenu = { ...this.props.menu }
        // newMenu.links = newMenu.links.concat(newLink);

        // console.log(newMenu)

        // updateMenu(this.props.menu.id, newMenu).then(() => {
        //   console.log('menu updated');
        // })
    }

    handleMenuCreate = () => {
        this.setState({
            isLoading: true,
        })

        createMenu(this.state.site).then((menu) => {
            // create menu in redux
            this.props.dispatch({
                type: SET_MENU,
                payload: {
                    menu,
                },
            })

            this.setState({
                isLoading: false,
            })
        })
    }

    render() {
        const { isLoading } = this.state

        return (
            <Layout>
                <div className="mb-12">
                    <div className="flex justify-between items-center mb-4">
                        <div className="w-4/5">
                            <div className="text-2xl font-semibold">
                                Site Menu
                            </div>
                            <div className="text-gray-700 text-sm">
                                Drag and drop to reorder menu, create
                                new links or sublinks. Press the Save
                                button to permanently make changes.
                            </div>
                        </div>
                        <div>
                            <button
                                disabled={
                                    !this.props.menu_has_changes
                                }
                                className={`px-3 py-2 rounded-lg ${
                                    this.props.menu_has_changes
                                        ? 'bg-blue-500 text-white'
                                        : 'bg-gray-300 text-gray-600 cursor-not-allowed'
                                }`}
                                onClick={this.saveMenu}
                            >
                                Save
                            </button>
                        </div>
                    </div>

                    <div>
                        {isLoading && <div>Loading menu...</div>}
                        {!isLoading &&
                            this.props.menu.empty === true && (
                                <div onClick={this.handleMenuCreate}>
                                    Create new menu
                                </div>
                            )}
                        {!isLoading &&
                            this.props.menu.links &&
                            !this.props.menu.empty && (
                                <div>
                                    <div>
                                        <SortableLinksList />
                                        <div
                                            className="hover:bg-gray-400 cursor-pointer bg-gray-300 w-full p-4 items-center flex justify-center my-4 rounded shadow-inner"
                                            onClick={
                                                this.newParentLink
                                            }
                                        >
                                            Add New Parent Link
                                        </div>
                                    </div>
                                </div>
                            )}
                    </div>
                </div>
            </Layout>
        )
    }
}

function mapStateToProps(state) {
    return {
        menu: state.menu,
        menu_has_changes: state.menu_has_changes,
    }
}

export default withRouter(connect(mapStateToProps)(Menu))
